import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/(app)/forgot-password/loading.js");
